<template>
<div v-if="loggedIn">
  <slot></slot>
  <button @click='logOut'>Log out</button> 
</div>
<div v-else id="firebaseui-auth-container"></div>
</template>

<script>
import firebaseui from 'firebaseui'
import { firebase  } from '../db';
export default {
  name: 'auth',
  data () {
    return {
      loggedIn: false
    }
  },
  methods: {
    logOut() { 
      firebase.auth().signOut();
    } 
  },
  mounted() {
    var uiConfig = {
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      ]
    };
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    if(!this.loggedIn){
      ui.start('#firebaseui-auth-container', uiConfig); 
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        this.loggedIn = true;
      } else if (this.loggedIn === true) {
        this.$router.push('/')
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Auth.vue